const prefix = process.env.NODE_ENV == 'production' ? "//infishwaibao.oss-cn-chengdu.aliyuncs.com/zyyzhenjiu/":"./";

export default class Anim {
    constructor() {
        this.images = [];
    }
    init(container) {
        let n = 144;

        let loadings = [];
        loadings.push(this.loadImage('down', prefix + "anim/down.png"));
        loadings.push(this.loadImage('up', prefix + "anim/up.png"));

        for (let i = 0; i < n; i++) {
            let s = "";
            if (i < 10) s = '00' + i;
            else if (i < 100) s = '0' + i;
            else {
                s = i;
            }
            let url = `铜人0${s}.png`;

            loadings.push(this.loadImage(i, prefix + "anim/list/" + url));
        }

        this.canvas = document.createElement('canvas');
        this.canvas.width = 512;
        this.canvas.height = 512;
        this.ctx = this.canvas.getContext('2d');
        this.canvas.style.width = "100%";
        this.canvas.style.height = '100%';
        this.ctx.fillStyle = "#d8f6ff";

        container.appendChild(this.canvas);

        this.canvas.addEventListener('mousedown', this.onMouseDwon.bind(this), false);
        this.canvas.addEventListener('mousemove', this.onMouseMove.bind(this), false);
        this.canvas.addEventListener('mouseup', this.onMouseUp.bind(this), false);
        this.canvas.addEventListener('mouseout', this.onMouseUp.bind(this), false);

        this.dtxTotal = 0;

        Promise.all( loadings ).then( rets=>{
           
            rets.forEach(item=>{
                this.images[item.i] = item.img;
            })
            this.angle = 0;
            this.updateAngle();
        });


    }

    loadImage(i, url) {
        return new Promise((resolve, reject) => {
            let img = new Image();
            img.src = url;
            img.onload = function () {
                resolve({ i, img });
            };
        });
    }
    onMouseDwon(event) {
        this.draging = true;
        this.startX = event.clientX;
    }

    onMouseMove(event) {
        if (this.draging) {
            let dtx = event.clientX - this.startX;
            this.dtxTotal -= dtx;
            this.startX = event.clientX;
            this.angle = this.dtxTotal / 1;

            if (this.angle > 360) this.angle -= 360;
            if (this.angle < -360) this.angle += 360;

            this.updateAngle();
        }
    }

    onMouseUp(event) {
        this.draging = false;
    }

    updateAngle() {
        let a = this.angle;
        if (a < 0) a += 360 * 10000;
        let index = Math.floor((a % 360) / 360 * 144);
        let image = this.images[index];
       
        
        this.ctx.clearRect(0,0, 512, 512);
       
        this.ctx.fillRect(0,0,512,512);
        this.ctx.drawImage(this.images['down'] ,0,0);
        this.ctx.drawImage(image, 0,0);
        this.ctx.drawImage(this.images['up'], 0,0);
    }

}